module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"login":"Login","register":"Register"},"in":{"login":"Masuk","register":"Daftar"}}')
  delete Component.options._Ctor
}
